import { isEmpty } from 'lodash4';
export class MyScheduleDetailFunction {
  static build(): MyScheduleDetailFunction {
    return new MyScheduleDetailFunction();
  }

  createShortDescription(textDescription: string) {
    let end: number;

    if (isEmpty(textDescription)) {
      return '';
    }

    if (textDescription.length < 100) {
      return textDescription + '\n';
    }

    end = textDescription.lastIndexOf(' ', 100);
    return textDescription.substr(0, end) + '...';
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/functions/my_schedule_detail_fn.ts